module.exports = __webpack_public_path__ + "94405622c54fbb5a6c876987d60c6a89.svg";